import { Card } from "@/components/ui/card";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen pt-24 pb-12 px-6">
      <div className="max-w-3xl mx-auto">
        <Card className="p-8">
          <h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
          <p className="text-muted-foreground mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>
          
          <div className="space-y-6 text-muted-foreground">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">What Are Cookies</h2>
              <p>
                Cookies are small text files that are stored on your computer or mobile device 
                when you visit a website. They are widely used to make websites work more efficiently 
                and provide information to the website owners.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">How We Use Cookies</h2>
              <p className="mb-2">Bodyz Gym uses cookies for the following purposes:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
                <li><strong>Authentication:</strong> To keep you logged in to your account</li>
                <li><strong>Preferences:</strong> To remember your settings and preferences</li>
                <li><strong>Analytics:</strong> To understand how visitors interact with our website</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Types of Cookies We Use</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-foreground">Session Cookies</h3>
                  <p>These are temporary cookies that expire when you close your browser.</p>
                </div>
                <div>
                  <h3 className="font-medium text-foreground">Persistent Cookies</h3>
                  <p>These remain on your device until they expire or you delete them.</p>
                </div>
                <div>
                  <h3 className="font-medium text-foreground">Third-Party Cookies</h3>
                  <p>Some cookies may be set by third-party services we use (e.g., authentication providers).</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Managing Cookies</h2>
              <p>
                Most web browsers allow you to control cookies through their settings. You can usually 
                find these settings in the &quot;Options&quot; or &quot;Preferences&quot; menu of your browser. 
                Please note that disabling cookies may affect the functionality of this website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Your Consent</h2>
              <p>
                By using Bodyz Gym, you consent to our use of cookies as described in this policy. 
                When you first visit our website, you will be shown a cookie consent banner where 
                you can manage your preferences.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Changes to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time. Any changes will be posted 
                on this page with an updated revision date.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">Contact Us</h2>
              <p>
                If you have any questions about our Cookie Policy, please contact us at 
                privacy@bodyz-gym.com.
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
}
